<template>
    <div class="position-settings">
        <el-form :inline="true" size="small" :model="dataForm" @keyup.enter.native="getDataList()">
            <el-form-item label="源采购组织代码:">
                <el-input size="small" v-model="dataForm.objectPurCode" placeholder="源采购组织代码" clearable></el-input>
            </el-form-item>
            <el-form-item label="目标采购组织代码:">
                <el-input size="small" v-model="dataForm.subjectPurCode" placeholder="目标采购组织代码" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size="small" @click="getDataList()" icon="el-icon-search">
                    查询
                </el-button>
                <el-button size="small" type="primary" name="but_add"
                           @click="addOrUpdateHandle()" icon="el-icon-plus">
                    新增
                </el-button>
            </el-form-item>
        </el-form>
        <el-table :data="dataList" v-loading="dataListLoading" size="small" :height=documentClientHeight
                  @selection-change="selectionChangeHandle" style="width: 100%;">
            <el-table-column type="selection" header-align="center" align="center" width="50">
            </el-table-column>
            <el-table-column type="index" label="序号" header-align="left" align="left" width="50">
            </el-table-column>
            <el-table-column prop="objectPurCode" header-align="left" align="left" width="120" label="源采购组织代码">
            </el-table-column>
            <el-table-column prop="objectPurName" header-align="left" align="left" width="150" label="源采购组织名称">
            </el-table-column>
            <el-table-column prop="subjectPurCode" header-align="left" align="left" width="120" label="目标采购组织代码">
            </el-table-column>
            <el-table-column prop="subjectPurName" header-align="left" align="left" width="150" label="目标采购组织名称">
            </el-table-column>
            <el-table-column prop="subjectWorkCode" header-align="left" align="left" width="100" label="目标工厂代码">
            </el-table-column>
            <el-table-column prop="subjectWorkName" header-align="left" align="left" width="150" label="目标工厂名称">
            </el-table-column>
            <el-table-column prop="createUser" header-align="left" align="left" width="80" label="创建用户">
            </el-table-column>
            <el-table-column prop="createTime" header-align="left" align="left" width="100" label="创建时间">
            </el-table-column>

            <el-table-column header-align="left" align="left" min-width="80" label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small"
                               @click="deleteHandle(scope.row.id)" icon="el-icon-delete">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex"
                       :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage"
                       layout="total, sizes, prev, pager, next, jumper">
        </el-pagination>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
</template>

<script>
    import {queryPage,
      deleteZgPrice,
      insertZgPrice,
      queryPurList,
      targetPurWorkList} from '@/controller/rfq'

    import AddOrUpdate from './zgPrice-add-or-update.vue'

    export default {
        data() {
            return {
                documentClientHeight: document.documentElement['clientHeight'] - 220,
                dataForm: {
                  subjectPurCode: '',
                  objectPurCode: ''
                },
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
            }
        },
        components: {
            AddOrUpdate,
        },
        activated() {
            this.getDataList()
        },
        methods: {
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true
              queryPage(
                    {
                        'pageNo': this.pageIndex,
                        'pageSize': this.pageSize,
                        'subjectPurCode': this.dataForm.subjectPurCode,
                        'objectPurCode': this.dataForm.objectPurCode,
                        'tenantId': sessionStorage.getItem('tenantId'),
                        'mainBodyId': sessionStorage.getItem('mainBodyId')
                    }
                ).then(data => {
                    if (data && data.code === '00') {
                        this.dataList = data.body.records
                        this.totalPage = data.body.total
                    } else {
                        this.dataList = []
                        this.totalPage = 0
                    }
                    this.dataListLoading = false
                })
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val
                this.pageIndex = 1
                this.getDataList()
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val
                this.getDataList()
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val
            },
            // 新增 / 修改
            addOrUpdateHandle(id) {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(id)
                })
            },
            // 删除
            deleteHandle(id) {
                this.$confirm(`确定进行删除操作?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                  deleteZgPrice(
                      {'id':id}
                    ).then(data => {
                        if (data && data.code === '00') {
                            this.$message({
                                message: '操作成功',
                                type: 'success',
                                duration: 1500,
                                onClose: () => {
                                    this.getDataList()
                                }
                            })
                        } else {
                            this.$message.error(data.msg)
                        }
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>
